const EntranceType = {
  REGISTER: 0, // 注册
  SMSLOGIN: 1, // 短信登录
  PWDLOGIN: 2, // 密码登录
  OTHERLOGIN: 3, // 其他登录
  FORGETPWD: 4 // 忘记密码
}

const VerifyType = {
  SMS: 0, // 手机号码
  EMAIL: 1 // 邮箱地址
}

export {
  EntranceType,
  VerifyType
}
